import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import TopHeader from "./topheader";

const Header = () => {
  const [isFixed, setIsFixed] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [startX, setStartX] = useState(null);
  const location = useLocation();
  const isMailProRoute = location.pathname === "/solutions/MailPro";
  const isActives = ![
    "/solutions/web",
    "/solutions/mobile",
    "/solutions/MailPro"
  ].includes(location.pathname);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsFixed(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleTouchStart = (e) => {
      setStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
      if (!startX) return;

      const diffX = startX - e.touches[0].clientX;
      if (diffX < -50) {
        setIsSidebarOpen(false);
      }
    };

    const handleTouchEnd = () => setStartX(null);

    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [startX]);

  return (
    <div className={isMailProRoute ? "mailpro-route" : ""}>
      <TopHeader />
      <header className={`header ${isFixed ? "fixed" : ""}`}>
        <div className="container-fluid">
          <div className="row">
            <div
              className={`col-3 d-flex justify-content-center align-items-center ${isFixed ? "mt3" : `${isActives ? "" : "div-logo"}`}`}
            >
              <img src="/assets/images/logo.png" className="logo logo-harder" alt="Logo Visibility CAM" />
            </div>

            <div className={`col-9 navbar navbar-expand-lg ${isActives ? "" : "div-nav"} ${isFixed ? "navigate" : ""}`}>
              <nav className="primary-nav" aria-label="Navigation principale">
                {!isSidebarOpen && (
                  <div className="collapse navbar-collapse" id="primary-menu">
                    <ul className="navbar-nav ms-auto w-100">
                      <li className="nav-item me-3">
                        <NavLink
                          to="/"
                          className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")}
                          data-key="t-dashboard"
                        >
                          V_CAM
                          <br />
                          <img src="/assets/images/line-shape-3.png" className="line-shape-3" alt="" aria-hidden="true" />
                        </NavLink>
                      </li>
                      <li
                        className={`nav-item dropdown me-3 ${isDropdownOpen ? "show" : ""}`}
                        onMouseEnter={() => setIsDropdownOpen(true)}
                        onMouseLeave={() => setIsDropdownOpen(false)}
                      >
                        <a
                          href="#"
                          className={`nav-link dropdown-toggle ${isActives ? "" : "green"}`}
                          data-bs-toggle="dropdown"
                          aria-expanded={isDropdownOpen}
                          data-key="t-solutions"
                          onClick={(e) => e.preventDefault()}
                        >
                          Nos Solutions
                        </a>
                          <ul className={`dropdown-menu ${isDropdownOpen ? "show" : ""}`}>
                            <li>
                              <NavLink to="/solutions/web" className="dropdown-item">
                                Nos Applications Web
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/solutions/mobile" className="dropdown-item">
                                Nos Applications Mobile
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/solutions/MailPro" className="dropdown-item">
                                E-mails Pro
                              </NavLink>
                            </li>
                          </ul>
                      </li>
                      <li className="nav-item me-3">
                        <NavLink
                          to="/services"
                          className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")}
                          data-key="t-services"
                        >
                          Nos Services
                          <br />
                          <img src="/assets/images/line-shape-3.png" className="line-shape-3" alt="" aria-hidden="true" />
                        </NavLink>
                      </li>
                      <li className="nav-item me-3">
                        <NavLink
                          to="/portfolio"
                          className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")}
                          data-key="t-portfolio"
                        >
                          Portfolio
                          <br />
                          <img src="/assets/images/line-shape-3.png" className="line-shape-3" alt="" aria-hidden="true" />
                        </NavLink>
                      </li>
                      <li className="nav-item me-3">
                        <NavLink
                          to="/blog"
                          className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")}
                          data-key="t-blog"
                        >
                          ActuBlog
                          <br />
                          <img src="/assets/images/line-shape-3.png" className="line-shape-3" alt="" aria-hidden="true" />
                        </NavLink>
                      </li>
                      <li className="nav-item me-3">
                        <NavLink
                          to="/postuler-stage"
                          className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")}
                          data-key="t-stagiaires"
                        >
                          Stagiaires
                          <br />
                          <img src="/assets/images/line-shape-3.png" className="line-shape-3" alt="" aria-hidden="true" />
                        </NavLink>
                      </li>
                      <li className="nav-item me-3">
                        <NavLink
                          to="/contact"
                          className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")}
                          data-key="t-contact"
                        >
                          Contacts
                          <br />
                          <img src="/assets/images/line-shape-3.png" className="line-shape-3" alt="" aria-hidden="true" />
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                )}
              </nav>
              <button
                type="button"
                className={`btn toggle-btn ${isFixed ? "navigate" : ""}`}
                onClick={toggleSidebar}
                aria-expanded={isSidebarOpen}
                aria-controls="sidebar-menu"
                aria-label="Afficher le menu mobile"
              >
                <i className={`${isSidebarOpen ? "fa-regular fa-circle-xmark" : "fa-solid fa-bars-staggered"}`}></i>
              </button>
            </div>
          </div>
        </div>
        <aside
          id="sidebar-menu"
          className={`sidebar ${isSidebarOpen ? "open" : ""}`}
          aria-label="Navigation mobile"
          aria-hidden={!isSidebarOpen}
        >
          <ul className="sidebar-nav">
            <li className="nav-item">
              <NavLink to="/" className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")} onClick={toggleSidebar}>
                V_CAM
              </NavLink>
            </li>
            <li
              className={`nav-item dropdown me-3 ${isDropdownOpen ? "show" : ""}`}
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              <a
                href="#"
                className={`nav-link dropdown-toggle ${isActives ? "" : "green"}`}
                data-bs-toggle="dropdown"
                aria-expanded={isDropdownOpen}
                data-key="t-solutions"
                onClick={(e) => e.preventDefault()}
              >
                Nos Solutions
              </a>
              <ul className={`dropdown-menu ${isDropdownOpen ? "show" : ""}`}>
                <li>
                  <NavLink to="/solutions/web" className="dropdown-item">
                    Nos Applications Web
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/solutions/mobile" className="dropdown-item">
                    Nos Applications Mobile
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/solutions/MailPro" className="dropdown-item">
                    E-mails Pro
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <NavLink to="/services" className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")} onClick={toggleSidebar}>
                Nos Services
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/portfolio" className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")} onClick={toggleSidebar}>
                Portfolio
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/blog" className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")} onClick={toggleSidebar}>
                ActuBlog
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/postuler-stage" className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")} onClick={toggleSidebar}>
                Stagiaires
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact" className={({ isActive }) => (isActive ? "nav-link green" : "nav-link")} onClick={toggleSidebar}>
                Contacts
              </NavLink>
            </li>
          </ul>
        </aside>
      </header>
      {isSidebarOpen && <div className="overlay" onClick={toggleSidebar}></div>}
    </div>
  );
};

export default Header;
